module.exports = __webpack_public_path__ + "static/Genoapay_background-612d0ce8203d1e1008c888a3b6f0d6db.png";